export default __webpack_public_path__ + "static/media/Yvonne.9c984e48.png";